import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConnectionService {
  constructor(private http: HttpClient) {}

  public async get(url: string, headers?: HttpHeaders) {
    return await this.http.get(`${url}`, { headers: headers }).toPromise();
  }

  public async post(
    url: string,
    body: any,
    headers?: HttpHeaders,
    responseType: any = 'json'
  ): Promise<any> {
    return await this.http
      .post<any>(`${url}`, body, {
        headers: headers,
        responseType: responseType || 'json',
      })
      .toPromise();
  }
}
